export default [
  {
    path: '/ai',
    name: 'AiHome',
    component: () => import('./views/AiHome.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ai/projects/:id_project',
    name: 'AiProjectDetail',
    component: () => import('./views/AiProjectDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ai/projects/:id_project/pick',
    name: 'AiImagePickerView',
    component: () => import('./views/AiImagePickerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ai/projects/:id_project/annotate/:id_annotation_set',
    name: 'AiTaggerView',
    component: () => import('./views/AiTaggerView.vue'),
    meta: { requiresAuth: true },
  },
]
